import { TemplatesManager } from "../../library-js/templates/TemplatesManager";
import { InspectorContainer } from "./containers/InspectorContainer";
import { BooleanField } from "./fields/BooleanField";
import { InspectorField } from "./fields/InspectorField";
import { NumberField } from "./fields/NumberField";
import { ContainerField as ContainerField } from "./fields/ContainerField";
import { StringField } from "./fields/StringField";
import { Inspector } from "./Inspector";
import { InspectorCreationInfo } from "./InspectorCreationInfo";
import { InspectorLibrary } from "./InspectorLibrary";
import { InspectorNameTransformer } from "./InspectorNameTransformer";
import { isPrimitive } from "../../library-js/tools/TypeUtilities";

export class InspectorCreator
{
  library:InspectorLibrary;
  templatesManager:TemplatesManager;
  transformNames:boolean = true;


  static with( templatesManager:TemplatesManager )
  {
    let creator = new InspectorCreator();
    creator.library = new InspectorLibrary();
    creator.templatesManager = templatesManager;

    return creator;
  }

  protected _processObjects = new Set<Object>();
  protected _inspector:Inspector;
  get inspector(){ return this._inspector; }
  

  create( root:any ):Inspector
  {
    let info = new InspectorCreationInfo();
    
    info.creator = this;
    info.root    = root;
    info.object  = root;

    this._inspector = new Inspector();
    this._inspector.root = root;

    this._inspector.element = this.templatesManager.createTemplate( Inspector.type.selector );


    if ( Array.isArray( root ) )
    {
      for ( let i = 0; i < root.length; i++)
      {
        this.createField( info, info.arrayEntry( i, null ), this._inspector.element );
      }
    }
    else
    {
      for ( let it in root )
      {
        if ( ! root.hasOwnProperty( it ) )
        { 
          continue;
        }

        this.createField( info, info.objectMember( it, null ), this._inspector.element );
      }
    }

    if ( this.library )
    {
      this.library.postProcess( this._inspector );
    }

    return this._inspector;
  }

  createField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, container:Element, checkLibrary:boolean = true )
  { 
    if ( ! isPrimitive( info.object ) &&  info.object != null && info.object != undefined )
    {
      if ( this._processObjects.has( info.object ) )
      {
        console.log( "Already created:", info.object, "from", parentInfo.object );
        return;
      }

      this._processObjects.add( info.object );
    }

    if ( checkLibrary && this.library.handles( parentInfo, info, container ) )
    {
      return;
    }


    if ( typeof info.object  === "string" )
    {
      this.addField( parentInfo, info, new StringField(), container );
    }
    else if ( typeof info.object === "number" )
    {
      this.addField( parentInfo, info, new NumberField(), container );
    }
    else if ( typeof info.object === "boolean" )
    {
      this.addField( parentInfo, info, new BooleanField(), container );
    }
    else
    {
      let containerField = new ContainerField();
      let childContainer = this.addField( parentInfo, info, containerField, container );
     
      let object = info.object;

      if ( Array.isArray( object ) )
      {
        let array = object as any[];

        for ( let i = 0; i < array.length; i++ )
        {
          let entryInfo = info.arrayEntry( i, containerField );
          this.createField( info, entryInfo, childContainer );
        }
        
      }
      else
      {
        for ( let it in object )
        {        
          let hasMember = object.hasOwnProperty( it );

          if ( ! hasMember )
          {
            continue;
          }

          let memberInfo = info.objectMember( it, containerField );
          this.createField( info, memberInfo, childContainer );
        }
      } 

      
    }
  }

  addField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, field:InspectorField<any>, parentContainer:Element )
  {
    field.info = info;
    field.createElement();

    let name = info.path + "";

    if ( this.transformNames )
    {
      name = InspectorNameTransformer.convert( name );
    }

    let container = InspectorContainer.create( name, this.templatesManager, field.element );
    

    this._inspector.fields.push( field );

    field.value = info.object;

    field.onChange.addListener(  ( v )=> { info.setValue( field.value );  }  )

    parentContainer.appendChild( container );

    field.onAddedToContainer();

    let newChildContainer = InspectorContainer.containerChildren.query( container );

    

    parentInfo.children.push( field );

    return newChildContainer;
  }

}